import { Injectable } from '@angular/core';
import { AddPlantFromDeviceType } from 'src/app/models/plant/plant.model';
import { AgendaCardType } from 'src/app/models/utils.model';

@Injectable()
export class PageDialogService {

  private _dialogTitle : string = "";

  private _addPlant : boolean = false;
  private _editPlant : boolean = false;
  private _sharePlant : boolean = false;
  private _addPlantFromDevice : AddPlantFromDeviceType = AddPlantFromDeviceType.NONE;

  private _addDevice : boolean = false;
  private _editDevice: boolean = false;

  private _addMaintenanceReminder: boolean = false;
  private _editMaintenanceReminder: boolean = false;
  private _deleteReminderMode: boolean = false;

  private _agendaType: AgendaCardType;
  private _deleteAgendaMode: boolean = false;

  private _archiveDeviceMode : boolean = false;
  private _deletePlantMode : boolean = false;
  private _cannotDeletePlantMode : boolean = false;
  private _unsharePlantMode: boolean = false;
  private _searchMode : boolean = false;
  private _deviceGallery : boolean = false;
  private _confirmChangeOwner: boolean = false;

  private _videoPreview: boolean = false;


  private _plantId : string = '';

  constructor() { }

  get dialogTitle() : string {
    return this._dialogTitle;
  }

  set dialogTitle(title: string) {
    this._dialogTitle = title;
  }

  get addPlant() : boolean {
    return this._addPlant;
  }

  set addPlant(value: boolean) {
    this._addPlant = value;
  }

  get editPlant() : boolean {
    return this._editPlant;
  }

  set editPlant(value: boolean) {
    this._editPlant = value;
  }

  get sharePlant() : boolean {
    return this._sharePlant;
  }

  set sharePlant(value: boolean) {
    this._sharePlant = value;
  }

  get addPlantFromDevice() : AddPlantFromDeviceType {
    return this._addPlantFromDevice;
  }

  set addPlantFromDevice(value: AddPlantFromDeviceType) {
    this._addPlantFromDevice = value;
  }

  get addDevice() : boolean {
    return this._addDevice;
  }

  set addDevice(value: boolean) {
    this._addDevice = value;
  }

  get editDevice() : boolean {
    return this._editDevice;
  }

  set editDevice(value: boolean) {
    this._editDevice = value;
  }

  get archiveDeviceMode() : boolean {
    return this._archiveDeviceMode;
  }

  set archiveDeviceMode(value: boolean) {
    this._archiveDeviceMode = value;
  }

  get searchMode() : boolean {
    return this._searchMode;
  }

  set searchMode(value: boolean) {
    this._searchMode = value;
  }

  get deletePlantMode() : boolean {
    return this._deletePlantMode;
  }

  set deletePlantMode(value: boolean) {
    this._deletePlantMode = value;
  }

  get cannotDeletePlantMode() : boolean {
    return this._cannotDeletePlantMode;
  }

  set cannotDeletePlantMode(value: boolean) {
    this._cannotDeletePlantMode = value;
  }

  public get unsharePlantMode(): boolean {
    return this._unsharePlantMode;
  }

  public set unsharePlantMode(value: boolean) {
    this._unsharePlantMode = value;
  }

  get deviceGallery() : boolean {
    return this._deviceGallery;
  }

  set deviceGallery(value : boolean) {
    this._deviceGallery = value;
  }

  get plantId() : string {
    return this._plantId;
  }

  set plantId(value : string) {
    this._plantId = value;
  }

  public get confirmChangeOwner(): boolean {
    return this._confirmChangeOwner;
  }
  public set confirmChangeOwner(value: boolean) {
    this._confirmChangeOwner = value;
  }

  public get addMaintenanceReminder(): boolean {
    return this._addMaintenanceReminder;
  }
  public set addMaintenanceReminder(value: boolean) {
    this._addMaintenanceReminder = value;
  }

  public get editMaintenanceReminder(): boolean {
    return this._editMaintenanceReminder;
  }
  public set editMaintenanceReminder(value: boolean) {
    this._editMaintenanceReminder = value;
  }

  public get deleteReminderMode(): boolean {
    return this._deleteReminderMode;
  }
  public set deleteReminderMode(value: boolean) {
    this._deleteReminderMode = value;
  }

  public get deleteAgendaMode(): boolean {
    return this._deleteAgendaMode;
  }
  public set deleteAgendaMode(value: boolean) {
    this._deleteAgendaMode = value;
  }

  public get agendaType(): AgendaCardType {
    return this._agendaType;
  }
  public set agendaType(value: AgendaCardType) {
    this._agendaType = value;
  }

  public get videoPreview(): boolean {
    return this._videoPreview;
  }
  public set videoPreview(value: boolean) {
    this._videoPreview = value;
  }

  public reset() {
    this.addDevice = false;
    this.addPlant = false;
    this.editDevice = false;
    this.editPlant = false;
    this.sharePlant = false;
    this.addPlantFromDevice = AddPlantFromDeviceType.NONE;
    this.archiveDeviceMode = false;
    this.deletePlantMode = false;
    this.cannotDeletePlantMode = false;
    this.unsharePlantMode = false;
    this.searchMode = false;
    this.deviceGallery = false;
    this.confirmChangeOwner = false;
    this.plantId = '';
    this.addMaintenanceReminder = false;
    this.editMaintenanceReminder = false;
    this.deleteReminderMode = false;
    this.deleteAgendaMode = false;
    this.videoPreview = false;
  }
}
